import React, { FC, useEffect, useState } from 'react';
import { TagsContainer, Tag } from './styled';

type TagsProps = {
    selectedTags?: string[];
    tags: { key: string; label: string }[];
    onChange: (chosen: string[]) => void;
    singleChoose?: boolean;
};

const Tags: FC<TagsProps> = ({ tags, onChange, singleChoose, selectedTags }) => {
    const [activeKeys, setActiveKeys] = useState<string[]>(selectedTags ?? []);
    const [isInitialize, setIsInitialized] = useState<boolean>(false);

    useEffect(() => {
        setActiveKeys(selectedTags ?? []);
    }, [selectedTags]);

    useEffect(() => {
        if (isInitialize) {
            onChange(activeKeys);
        }
    }, [activeKeys]);

    useEffect(() => {
        setIsInitialized(true);
    }, []);

    return (
        <TagsContainer>
            {tags.map((t) => (
                <Tag
                    active={activeKeys.some((key) => key === t.key)}
                    key={t.key}
                    onClick={() => {
                        if (singleChoose) {
                            if (activeKeys[0] === t.key) {
                                setActiveKeys([]);
                            } else {
                                setActiveKeys([t.key]);
                            }
                            return;
                        }

                        if (activeKeys.some((key) => key === t.key)) {
                            setActiveKeys(activeKeys.filter((key) => key !== t.key));
                        } else {
                            setActiveKeys((prevState) => [...prevState, t.key]);
                        }
                    }}
                >
                    {t.label}
                </Tag>
            ))}
        </TagsContainer>
    );
};

export default Tags;
